// extracted by mini-css-extract-plugin
module.exports = {"navigationTabs":"footer_navigationTabs__3G7L6","navigationItem":"footer_navigationItem__2y3JQ"};